import React from 'react'
import { SxProps } from '@mui/material'

import { useAnalysisTypeAnalyses } from 'redux/hooks/Analyses'
import { useAccountSettings } from 'redux/hooks/SignedInAccount'
import { useParams } from 'utils/hooks'
import { useTranslation } from 'language/translator'

import Box from 'components_new/atoms/Box'

import NavigationItem from 'components_new/molecules/NavigationItem'

interface AnalysisTypeNavigationProps {
  sx?: SxProps
}

const AnalysisTypeNavigation = (props: AnalysisTypeNavigationProps) => {
  const { sx } = props
  const { id } = useParams<{ id: string }>()

  const { unhandled, error, loading } = useAnalysisTypeAnalyses(id)
  const { isAdmin } = useAccountSettings()
  const { t } = useTranslation()

  return (
    <>
      <Box sx={sx}>
        <NavigationItem
          item={{
            activePattern: `/analysis-types/${id}`,
            href: `/analysis-types/${id}`,
            icon: { name: 'Image' },
            title: t('global', 'overview')
          }}
        />
        <NavigationItem
          item={{
            activePattern: `/analysis-types/${id}/analyses*`,
            chip:
              loading || error
                ? undefined
                : {
                    color: 'success',
                    label: unhandled.length
                  },
            href: `/analysis-types/${id}/analyses`,
            icon: { name: 'Analyses' },
            title: t('analyses', 'analyses')
          }}
        />
        <NavigationItem
          item={{
            activePattern: `/analysis-types/${id}/settings*`,
            disabled: !isAdmin,
            href: `/analysis-types/${id}/settings`,
            icon: { name: 'Settings' },
            title: t('global', 'settings')
          }}
        />
      </Box>
    </>
  )
}

export default AnalysisTypeNavigation
